import $ from 'jquery';
import {PageController} from "./PageController";

export class GtmDataLayerController extends PageController {

    constructor() {
        super();
    };

    init() {
        this.setFlagThatGtmControllerIsInPlace();
        this.addEventListeners();
        this.onPageLoad();
    };

    setFlagThatGtmControllerIsInPlace() {
        window.gtmControllerDeployed = true;
    };

    addEventListeners() {
        $(document).on('click', 'a[href]:not([data-gtm-method]), [data-gtm-attributes]:not([data-gtm-method], [data-link-alias-href])',  this.onGenericClick.bind(this));

        // forms
        $(document).on('submit', 'form[data-gtm-method="onGlobalSearch"]',  this.onGlobalSearch.bind(this));        
        $(document).on('submit', 'form[data-gtm-method="onLoginFormSubmit"]',  this.onLoginFormSubmit.bind(this));        
        $(document).on('submit', 'form[data-gtm-method="onRegistrationFormSubmit"]',  this.onRegistrationFormSubmit.bind(this));   
        $('button[data-gtm-method="onRegistrationFormButtonClick"]').on('click', this.onRegistrationFormButtonClick.bind(this));

        $(document).on('submit', 'form[data-gtm-method="onDocumentSearch"]',  this.onDocumentSearch.bind(this));
        $(document).on('submit', 'form[data-gtm-method="onGlossaryFormSubmit"]',  this.onGlossaryFormSubmit.bind(this));
        $(document).on('submit', 'form:not([data-gtm-method])',  this.onGenericFormSubmit.bind(this));

        // custom handlers
        $(document).on('click', '[data-gtm-method="onPrintClick"]',  this.onPrintClick.bind(this));
        $(document).on('click', '[data-gtm-method="onFundFollow"]',  this.onFundFollow.bind(this));
        $(document).on('click', '[data-gtm-method="onFundSearchClear"]',  this.onFundSearchClear.bind(this));
        $(document).on('click', '[data-gtm-method="onArticleSearchClear"]',  this.onArticleSearchClear.bind(this));
        $(document).on('click', '[data-gtm-method="onGlobalSearchClear"]',  this.onGlobalSearchClear.bind(this));
        $(document).on('click', '[data-gtm-method="onGlobalSearchFacet"]',  this.onGlobalSearchFacet.bind(this));

        $(document).on('click', '[data-link-alias-href]', this.onLinkAliasClick.bind(this));
    };

    onGenericClick(event) {
        try {
            const element = event.currentTarget;

            if (!element) return;
            
            if (element.tagName.toLowerCase() !== 'a' && element.tagName.toLowerCase() !== 'button' && !element.getAttribute('data-gtm-attributes')) {
                return;
            }

            const href = element.getAttribute('href');
            if (href === '#' || href === '') { // Elements without href attribute pass through as `null`
                return;
            }
        
            const elementAsObject = this.getGtmElementLinkProperties(element);
            this.dataLayerPush(elementAsObject);
        } catch (err) {
            console.error(`GTM event handler error`, err);
        }
    };

    onPrintClick(element) {
        if (element.currentTarget) {
            const eventObject = this.getGtmElementLinkProperties(element.currentTarget);
            this.dataLayerPush(eventObject);
        }
    }

    dataLayerPush(object) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(object);
    };

    parseGtmAttributes(data) {
        let formattedData = data ? data.replaceAll('|', '"') : '';
        formattedData = `{${formattedData}}`;
        return JSON.parse(formattedData);
    };

    onPageLoad() {
        if (window.pageView) {
            this.dataLayerPush(window.pageView);
        }
    }

    isExternalLink(link) {
        return (link.host !== window.location.host);
    }

    onSearchSubmit(searchTerm, searchType, filterAssetClass, filterRegion, filterFund, filterFundRange, filterFundType, filterFocus, filterCurrency, filterPagetype, filterDocumenttype) {
        eventObj = new Object();
        eventObj.event = 'search_action';
        eventObj.eventName = 'search';
        eventObj.search_term = searchTerm ? searchTerm : null;
        eventObj.search_type = searchType ? searchType : null;
        eventObj.filter_asset_class = filterAssetClass ? filterAssetClass : null;
        eventObj.filter_region = filterRegion ? filterRegion : null;
        eventObj.filter_fund = filterFund ? filterFund : null;
        eventObj.filter_fund_range = filterFundRange ? filterFundRange : null;
        eventObj.filter_fund_type = filterFundType ? filterFundType : null;
        eventObj.filter_focus = filterFocus ? filterFocus : null;
        eventObj.filter_currency = filterCurrency ? filterCurrency : null;
        eventObj.filter_pagetype = filterPagetype ? filterPagetype : null;
        eventObj.filter_documenttype = filterDocumenttype ? filterDocumenttype : null;
        this.dataLayerPush(eventObj);
    }

    onGlobalSearch(element) {
        let form = element.currentTarget;
        var pageType = this.getParamFromUrl(form.action, 'pageType');
        var term = $(form).find('input[name="q"]').val();
        if (term) {
            term = term.toLowerCase();
        }
        this.onSearchSubmit(term, 'sitewide', null, null, null, null, null, null, null, pageType, null);
    };

    onGlobalSearchFacet(element) {
        let atag = element.currentTarget;
        var pageType = this.getParamFromUrl(atag.href, 'pageType');
        var term = this.getParamFromUrl(atag.href, 'q');
        this.onSearchSubmit(term, 'sitewide', null, null, null, null, null, null, null, pageType, null);
    };

    onGlobalSearchClear() {
        this.onSearchSubmit(null, 'sitewide', null, null, null, null, null, null, null, null, null);
    };

    onArticleSearch(url) {
        var term = this.getParamFromUrl(url, 'q');
        var assetClass = this.getParamFromUrl(url, 'assetclass');
        var region = this.getParamFromUrl(url, 'region');
        var fund = this.getParamFromUrl(url, 'fund');
        this.onSearchSubmit(term, 'insights', assetClass, region, fund, null, null, null, null, null, null);
    };

    onArticleSearchClear() {
        this.onSearchSubmit(null, 'insights', null, null, null, null, null, null, null, null, null);
    };

    onFundSearchBar(url) {
        var term = this.getParamFromUrl(url, 'q');
        var fundRanges = this.getParamFromUrl(url, 'ac');
        var fundRegions = this.getParamFromUrl(url, 'r');
        var focuses = this.getParamFromUrl(url, 'f');
        var assetClasses = this.getParamFromUrl(url, 'sc');
        var currencies = this.getParamFromUrl(url, 'c');
        var fundTypes = this.getParamFromUrl(url, 'ft');
        this.onSearchSubmit(term, 'funds', assetClasses, fundRegions, null, fundRanges, fundTypes, focuses, currencies, null, null);
    };

    onFundSearch(term, activeFilters) {
        var termValue = null;
        if (term) {
            termValue = term.toLowerCase();
        }

        const fundRanges = this.getValuesFromActiveFilters(activeFilters, 'AssetClass');
        const fundRegions = this.getValuesFromActiveFilters(activeFilters, 'Region');
        const focuses = this.getValuesFromActiveFilters(activeFilters, 'Focus');
        const assetClasses = this.getValuesFromActiveFilters(activeFilters, 'ShortClassName');
        const currencies = this.getValuesFromActiveFilters(activeFilters, 'Currency');
        const fundTypes = this.getValuesFromActiveFilters(activeFilters, 'FundType');
        this.onSearchSubmit(termValue, 'funds', assetClasses, fundRegions, null, fundRanges, fundTypes, focuses, currencies, null, null);
    };

    onFundSearchClear() {
        this.onSearchSubmit(null, 'funds', null, null, null, null, null, null, null, null, null);
    };

    onDocumentSearch(element) {
        let form = element.currentTarget;
        var fund = $(form).find('select[name="fundId"] option:selected').text();
        if (fund) {
            fund = fund.toLowerCase();
        }
        else {
            fund = null;
        }
        var documentType = $(form).find('select[name="documentType"]').val();
        if (documentType) {
            documentType = documentType.toLowerCase();
        }
        else {
            documentType = null;
        }

        this.onSearchSubmit(null, 'documents', null, null, fund, null, null, null, null, null, documentType);
    };

    getValuesFromActiveFilters(activeFilters, filterName) {
        var values = activeFilters.reduce((acc, cur) => ((cur.active && cur.filter == filterName && acc.push(cur.value)), acc), []);
        if (values && values.length > 0) {
            return values.join('|').toLowerCase();
        }
        return null;
    }

    getParamFromUrl(url, paramName) {
        var paramArr = url.slice(url.indexOf('?') + 1);
        var paramValue = null;
        if (paramArr) {
            var urlParams = new URLSearchParams(paramArr);
            var paramValues = urlParams.getAll(paramName);
            if (paramValues) {
                paramValue = paramValues.join('|').toLowerCase();
            }
        }
        return paramValue;
    }

    getGtmElementLinkProperties(element, defaults) {
        const eventObject = {
            // Defaults
            event: 'link_click',
            eventName: 'click',
            widget_format: element.className && element.className.indexOf('button') >= 0 ? 'button' : 'text',
            widget_type: 'page_content',
            link_id: element.id ? element.id.toLowerCase() : null,
            link_classes: element.className ? element.className.toLowerCase() : null,
            ...defaults
        };

        const gtmAttributes = element.dataset?.gtmAttributes;
        if (gtmAttributes) {
            Object.assign(eventObject, this.parseGtmAttributes(gtmAttributes));
        }

        const linkUrl = eventObject.link_url ? eventObject.link_url : element.href ? element.href : element.baseURI;
        let  url;
        try {
            url = new URL(linkUrl, document.body.baseURI);
        } catch {
            url = { href: eventObject.link_url };
        }

        eventObject.link_url = url.href ? url.href.toLowerCase() : null;
        eventObject.link_domain = url.hostname ? url.hostname.toLowerCase() : null;
        eventObject.outbound = this.isExternalLink(url).toString();

        const innerText = (eventObject.link_text || element.innerText || '').trim();
        eventObject.link_text = innerText ? innerText.toLowerCase() : null;

        return eventObject;        
    }

    onRegistrationFormButtonClick(element) {        
        var formElement = element.currentTarget.parentElement;
        var formSubmitText = $(element.currentTarget).text() ? $(element.currentTarget).text().toLowerCase() : null;
        if (formElement) {
            this.onFormSubmit('register', 'registration form', formElement.id.toLowerCase(), formElement.action.toLowerCase(), formSubmitText, 'registration form');
        }
    }

    onRegistrationFormSubmit(element) {
        this.onFormSubmit('register', 'registration form', element.id.toLowerCase(), element.action.toLowerCase(), this.getSubmitText(element.currentTarget), 'registration form');
    }

    onLoginFormSubmit(element) {
        this.onFormSubmit('login', 'login form', element.currentTarget.id.toLowerCase(), element.currentTarget.action.toLowerCase(), this.getSubmitText(element.currentTarget), 'login form');
    }

    onGenericFormSubmit(element) {
        if (element.currentTarget.id) {
            this.onFormSubmit('form_submit', 'other', element.currentTarget.id.toLowerCase(), element.currentTarget.action.toLowerCase(), this.getSubmitText(element.currentTarget), 'page_content')
        }
    }

    onGlossaryFormSubmit(element) {
        if (element.currentTarget.id) {
            this.onFormSubmit('form_submit', 'other', element.currentTarget.id.toLowerCase(), element.currentTarget.action.toLowerCase(), element.currentTarget[0].value, 'page_content')
        }
    }

    onFormSubmit(eventName, formName, formId, destination, formSubmitText, widgetType) {
        eventObj = new Object();
        eventObj.event = 'form_submit';
        eventObj.eventName = eventName;
        eventObj.form_name = formName;
        eventObj.form_id = formId;
        eventObj.form_destination = destination;
        eventObj.form_submit_text = formSubmitText;
        eventObj.widget_format = 'form';
        eventObj.widget_type = widgetType;
        this.dataLayerPush(eventObj);
    }

    getSubmitText(form) {
        var formSubmitText = null;
        var formSubmitButton = $(form).find('button[type="submit"]');
        if (formSubmitButton && formSubmitButton.text()) {
            formSubmitText = formSubmitButton.text().toLowerCase();
        }
        return formSubmitText;
    }

    onFundFollow(event) {
        const button = $(event.currentTarget);
        const eventObj = {
            event: 'link_click',
            eventName: 'follow_fund',
            link_classes: button.attr('class') ? button.attr('class').toLowerCase() : null,
            link_domain: window.location.host,
            link_id: button.id ? button.id.toLowerCase() : null,
            link_url: window.location.pathname,
            link_text: button ? button.text().toLowerCase() : null,
            outbound: "false",
            widget_format: 'button',
            widget_type: 'fund explorer'
        }
        this.dataLayerPush(eventObj);
    }

    onLinkAliasClick(event) {
        const element = event.currentTarget;
        const url = element.dataset.linkAliasHref;
        if (!url) return;

        try {
            const eventObject = this.getGtmElementLinkProperties(element, { link_url: url });
            this.dataLayerPush(eventObject);
        } catch (err) {
            console.error(`GTM event handler error`, err);
        }

        const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        const hasNewTabModifier = isMac ? event.metaKey : event.ctrlKey;
        const hasNewWindowModifier = isMac ? event.altKey : event.shiftKey;
        
        if (hasNewTabModifier) {
            window.open(url, '_blank', 'noopener,noreferrer');
        } else if (hasNewWindowModifier) {
            window.open(url, '_blank', `noopener,noreferrer,width=${window.outerWidth},height=${window.outerHeight},location=yes,menubar=yes,scrollbars=yes,status=yes`);
        } else {
            window.location = url;
        }

        event.preventDefault();
    }
}

GtmDataLayerController.start = function () {
    return new GtmDataLayerController();
};

export var render = function () {
    var gtm = new GtmDataLayerController();
    gtm.init();
    return gtm;
};
